// extracted by mini-css-extract-plugin
module.exports = {"sweetLoading":"styles_sweetLoading__ZPxGZ","backgroundLoading":"styles_backgroundLoading__1x0Jc"};